// extracted by mini-css-extract-plugin
export default {"wrapper":"CreateSpaceModal_wrapper__pJKRe"};